<!-- template is directly on the cshtml page type 'ModelDetailsPage' -->
<script>
    import _ from 'lodash';
    import axios from 'axios';
    import { enableSpinner, disableSpinner } from '../js/spinner.js';

    import ModelDetailsInfoBox from './ModelDetailsInfoBox.vue';
    import ModelDetailsTaxBaseOverview from './ModelDetailsTaxBaseOverview.vue';
    import ModelDetailsStandardEquipment from './ModelDetailsStandardEquipment.vue';
    import ModelDetailsExtraEquipment from './ModelDetailsExtraEquipment.vue';
    import ModelDetailsDeliveryDeadlines from './ModelDetailsDeliveryDeadlines.vue';

    export default {
        name: 'model-details',
        template: "#model-details-page",
        props: {
            deliveryDeadlineText: {
                type: String,
                default: undefined
            },
            pModelName: {
                type: String,
                default: undefined
            },
            pCarModelVariants: {
                type: Array,
                default: undefined
            },
            pStandardEquipmentGroups: {
                type: Array,
                default: undefined
            },
            pExtraEquipmentGroups: {
                type: Array,
                default: undefined
            },
            pColorGroups: {
                type: Array,
                default: undefined
            },
            pModelId: {
                type: String,
                default: undefined
            }
        },
        data() {
            return {
                detailsData: {
                    modelName: this.pModelName,
                    carModelVariants: this.pCarModelVariants,
                    standardEquipmentGroups: this.pStandardEquipmentGroups,
                    extraEquipmentGroups: this.pExtraEquipmentGroups,
                    colorGroups: this.pColorGroups
                },
                selectedTabIndex: 1
            }
        },
        computed: {
            currentModelId: function () {
                return this.$props.pModelId;
            },
            modelName: function () {
                if (this.detailsData !== undefined) {
                    return this.detailsData.modelName;
                }

                return undefined;
            },
            carVariants: function () {
                if (this.detailsData !== undefined) {
                    return this.detailsData.carModelVariants;
                }

                return [];
            },
            standardEquipmentGroups: function () {
                if (this.detailsData !== undefined) {
                    return this.detailsData.standardEquipmentGroups;
                }

                return undefined;
            },
            isStandardEquipmentAvailable: function () {
                if (this.detailsData !== undefined) {
                    return this.detailsData.standardEquipmentGroups.some(group => group.standardEquipmentCategories?.length > 0);
                }

                return true;
            },
            extraEquipmentGroups: function () {
                if (this.detailsData !== undefined) {
                    return this.detailsData.extraEquipmentGroups;
                }

                return undefined;
            },
            isExtraEquipmentAvailable: function () {
                if (this.detailsData !== undefined) {
                    return this.detailsData.extraEquipmentGroups.some(group => group.extraEquipment?.length > 0);
                }

                return true;
            },
            colorGroups: function () {
                if( this.detailsData !== undefined) {
                    return this.detailsData.colorGroups;
                }
                return undefined;
            },
            isColorAvailable: function () {
                if(this.detailsData !== undefined){
                    return this.detailsData.colorGroups.some(group => group.colors?.length > 0);
                }
                return true;
            },
            deliveryDeadline: function () {
                if (this.$props.deliveryDeadlineText !== undefined) {
                    return this.$props.deliveryDeadlineText;
                }

                return undefined;
            },
            isDeliveryDeadlineTextAvailable: function () {
                if (this.$props.deliveryDeadlineText) {
                    return true;
                }

                return false;
            }
        },
        watch: {
            selectedTabIndex: function (tabIndex) {
                //View retrofitted equipment (3)
                if (tabIndex === 3) {
                    //start spinner if user hit tab before data is loaded
                    if (this.retrofittedDataLoading) {
                        enableSpinner();
                    }
                }
            },
            retrofittedDataLoading: function (isLoading) {
                //View retrofitted equipment (3)
                if (this.selectedTabIndex === 3) {
                    //stop spinner when data is loaded in tab
                    if (!isLoading) {
                        disableSpinner();
                    }
                }
            }
        },
        components: {
            ModelDetailsInfoBox,
            ModelDetailsTaxBaseOverview,
            ModelDetailsStandardEquipment,
            ModelDetailsExtraEquipment,
            ModelDetailsDeliveryDeadlines
        }
    }
</script>